<!--
 * @Author: aisi
 * @Date: 2020-01-04 09:44:40
 * @LastEditTime : 2020-01-07 14:43:14
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /vue/wei/src/views/analyseWord/studySurvey/CourseAverage.vue
-->
<template>
  <div class="bar">
    <div :id="id" style="height:350px"></div>
  </div>
</template>
<script>
// 引入 ECharts 主模块
const echarts = require('echarts/lib/echarts')
// 引入散点图
require('echarts/lib/chart/scatter')
// 引入图表标线
require('echarts/lib/component/markLine')
export default {
  props: ['id', 'color', 'seriesData', 'yname', 'xname'],
  mounted() {
    let dom = echarts.init(document.getElementById(this.id), null, {
      renderer: 'svg'
    })
    dom.setOption({
      color: this.color,
      xAxis: {
        type: 'value',
        min: function(value) {
          return Math.round(value.min - 1)
        },
        name: this.xname
      },
      yAxis: {
        type: 'value',
        name: this.yname
      },
      series: [
        {
          type: 'scatter',
          label: {
            show: true,
            position: 'top',
            formatter: '{b}'
          },
          data: this.seriesData,
          markLine: {
            data: [
              { type: 'average', name: 'y', valueIndex: 0 },
              { type: 'average', name: 'x' }
            ]
          }
        }
      ]
    })
  }
}
</script>
<style lang="scss" scoped></style>
